import { ConnectButton } from "@rainbow-me/rainbowkit";

function VotingDelegation({ disabled, buttonClassName, onSetConnectingWallet }) {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        return (
          <div
            className="w-100"
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                return <button
                  className={buttonClassName}
                  disabled={disabled}
                  onClick={(event) => {
                    openConnectModal(event);
                    onSetConnectingWallet(true);
                  }}
                >
                  Save Changes
                </button>;
              }
              if (chain.unsupported) {
                return <button
                  className={buttonClassName}
                  disabled={disabled}
                  onClick={openChainModal}
                >
                  Save Changes
                </button>;
              }

              return <button
                className={buttonClassName}
                disabled={disabled}
                onClick={openAccountModal}
              >
                Save Changes
              </button>;
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}

export default VotingDelegation;
